import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "./api";

/** Resolve event id from `/:citySlug/:eventSlug/...` routes. */
export function useResolvedEventId() {
  const { citySlug, eventSlug } = useParams();
  const [resolvedId, setResolvedId] = useState(null);
  const [resolving, setResolving] = useState(Boolean(citySlug && eventSlug));
  const [resolveError, setResolveError] = useState(null);
  const [resolveAttempt, setResolveAttempt] = useState(0);

  const retryResolve = useCallback(() => {
    setResolveAttempt((n) => n + 1);
  }, []);

  useEffect(() => {
    if (!citySlug || !eventSlug) {
      setResolvedId(null);
      setResolving(false);
      setResolveError(null);
      return undefined;
    }
    let cancelled = false;
    setResolving(true);
    setResolveError(null);
    api
      .get(`/events/by-path/${encodeURIComponent(citySlug)}/${encodeURIComponent(eventSlug)}`)
      .then((r) => {
        if (!cancelled) {
          setResolvedId(r.data.id);
          setResolveError(null);
        }
      })
      .catch((e) => {
        if (!cancelled) {
          setResolvedId(null);
          const status = e?.response?.status;
          setResolveError(status === 404 ? "not_found" : "error");
        }
      })
      .finally(() => {
        if (!cancelled) setResolving(false);
      });
    return () => {
      cancelled = true;
    };
  }, [citySlug, eventSlug, resolveAttempt]);

  return { eventId: resolvedId, resolving, resolveError, retryResolve };
}
